import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AppState {
    // UI State
    sidebarCollapsed: boolean;
    theme: 'light' | 'dark';
    language: string;
    
    // Notifications
    notifications: any[];
    
    // User related data
    permissions: any[];
    menus: any[];
    userName: string;
    
    // Actions
    toggleSidebar: () => void;
    setSidebarCollapsed: (collapsed: boolean) => void;
    setTheme: (theme: 'light' | 'dark') => void;
    setLanguage: (language: string) => void;
    addNotification: (notification: any) => void;
    removeNotification: (id: string) => void;
    clearNotifications: () => void;
    setPermissions: (permissions: any[]) => void;
    setMenus: (menus: any[]) => void;
    setUserName: (userName: string) => void;
}

export const useAppStore = create<AppState>()(
    persist(
        (set, get) => ({
            // Initial state
            sidebarCollapsed: false,
            theme: 'light',
            language: 'en',
            notifications: [],
            permissions: [],
            menus: [],
            userName: '',

            // Actions
            toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
            setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
            setTheme: (theme) => set({ theme }),
            setLanguage: (language) => set({ language }),
            
            addNotification: (notification) => set((state) => ({
                notifications: [...state.notifications, { ...notification, id: Date.now().toString() }]
            })),
            
            removeNotification: (id) => set((state) => ({
                notifications: state.notifications.filter(notif => notif.id !== id)
            })),
            
            clearNotifications: () => set({ notifications: [] }),
            
            setPermissions: (permissions) => set({ permissions }),
            setMenus: (menus) => set({ menus }),
            setUserName: (userName) => set({ userName }),
        }),
        {
            name: 'app-storage',
            partialize: (state) => ({
                sidebarCollapsed: state.sidebarCollapsed,
                theme: state.theme,
                language: state.language,
                permissions: state.permissions,
                menus: state.menus,
                userName: state.userName,
            }),
        }
    )
); 